export interface ProgressIdleProps {
  isDark: boolean;
}
const ProgressIdle = ({ isDark }: ProgressIdleProps) => {
  const stopColor0 = isDark ? "#1D3E45" : "#FFFFFF";
  const stopColor1 = isDark ? "#2D6470" : "#F0FAFA";
  const likeStroke = isDark ? "#2D6470" : "#DFE1E5";
  return (
    <div>
      <svg x="0" y="0" viewBox="0 0 389 220">
        <g id="Progress_BG">
          <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1="194.3333"
            y1="18.3923"
            x2="194.3333"
            y2="209.0588"
            gradientTransform="matrix(1 0 0 -1 0 222)"
          >
            <stop offset="0" stopColor={stopColor0} />
            <stop offset="1" stopColor={stopColor1} />
          </linearGradient>
          <path
            fill="url(#SVGID_1_)"
            d="M365.5,130.6c10.7,26.8,41.4,48.8-5.4,68.8c-14.5,6.2-65.3-17.2-89.6-11.4 c-23.9,5.7-42.9,12.8-68.1,14.9c-38.1,3.3-51.2-5.3-83.4-12.4c-20.5-4.5-40.3,3.5-58.4,0.6c-48.9-7.7-82.8-68.2-43.2-106.7 C30.3,72,52,73.8,67.7,61.1c25.4-20.2,11.6-45,57.2-43.7c45.3,1.2,71.1,27.7,121.5,17.9c33.3-6.5,117.9-48.5,139.6,2.6 C400.4,71.7,351.8,93.2,365.5,130.6z"
          />
        </g>
        <g id="Progress_Divider">
          <line
            fill="none"
            stroke={likeStroke}
            strokeWidth="1.3"
            strokeLinecap="round"
            x1="194.8"
            y1="0.6"
            x2="194.8"
            y2="219.4"
          />
        </g>
        <g id="Progress_Left">
          <path
            fill="#FAFAFA"
            stroke="#FFB672"
            strokeWidth="3"
            d="M87.7,37.2c-4-0.7-7.7,2.3-7.7,6.4v132.8c0,4.1,3.8,7.2,7.8,6.4
					l80.6-16.1c3-0.6,5.2-3.3,5.2-6.4V58.5c0-3.1-2.2-5.8-5.3-6.4L87.7,37.2z"
          />
          <path
            className="progressBox"
            fill="#EEEEEE"
            stroke="#ffb672"
            strokeWidth="1"
            d="M90.6,50.3c0-1.3,1.1-2.2,2.4-2l49.1,9.6c0.9,0.2,1.6,1,1.6,2v46.4c0,1.1-0.9,2-2.1,2l-49.1-2.1
					c-1.1,0-1.9-0.9-1.9-2V50.3z"
          />
          <path
            className="progressBox"
            fill="#EEEEEE"
            stroke="#ffb672"
            strokeWidth="1"
            d="M90.6,116.5c0-1.1,0.9-2,2-2l49.1,0.7c1.1,0,2,0.9,2,2v15.6c0,1.1-0.8,1.9-1.9,2L92.7,138
					c-1.2,0.1-2.1-0.8-2.1-2V116.5z"
          />
          <path
            className="progressBox"
            fill="#EEEEEE"
            stroke="#ffb672"
            strokeWidth="1"
            d="M90.6,148.1c0-1,0.8-1.9,1.8-2l49.1-4.5c1.2-0.1,2.2,0.8,2.2,2v13.9c0,1-0.7,1.8-1.7,2l-49.1,8.4
					c-1.2,0.2-2.3-0.7-2.3-2V148.1z"
          />
          <path
            className="progressBox"
            fill="#EEEEEE"
            stroke="#ffb672"
            strokeWidth="1"
            d="M150.1,61.9c0-1.2,1.1-2.2,2.4-2l10.2,1.9c1,0.2,1.6,1,1.6,2v89.8c0,1-0.7,1.8-1.6,2l-10.2,1.9
					c-1.2,0.2-2.4-0.7-2.4-2V61.9z"
          />
        </g>
        <g id="Progress_Right" opacity="0.6">
          <linearGradient
            id="SVGID_2_"
            gradientUnits="userSpaceOnUse"
            x1="67.8423"
            y1="-55.7965"
            x2="392.9881"
            y2="209.0842"
          >
            <stop offset="0" stopColor="#39B1C8" />
            <stop offset="0.7379" stopColor="#86E7F9" />
            <stop offset="1" stopColor="#FFFFFF" />
          </linearGradient>
          <path
            fill="url(#SVGID_2_)"
            d="M306.8,37.4c-1.8-1.5-4.2-2.2-6.6-1.7l-80.6,15c-3.8,0.7-6.5,4-6.5,7.9v101.7c0,3.8,2.7,7.1,6.4,7.8
					l80.6,16.1c0.5,0.1,1.1,0.2,1.6,0.2c1.8,0,3.6-0.6,5.1-1.8c1.9-1.5,2.9-3.8,2.9-6.2V43.5C309.7,41.2,308.7,38.9,306.8,37.4z"
          />
          <path
            fill="none"
            stroke="#F3F5F6"
            strokeWidth="0.5"
            d="M306.5,43.5c0-3-2.7-5.2-5.6-4.7l-80.6,15c-2.3,0.4-3.9,2.4-3.9,4.7
					v101.7c0,2.3,1.6,4.2,3.8,4.7l80.6,16.1c2.9,0.6,5.7-1.7,5.7-4.7V43.5z"
          />
          <path
            className="progressBox"
            fill="none"
            stroke="#F3F5F6"
            d="M237.6,61.9c0-0.9-0.8-1.6-1.8-1.5l-10.2,1.9c-0.7,0.1-1.2,0.8-1.2,1.5v89.8
					c0,0.7,0.5,1.3,1.2,1.5l10.2,1.9c0.9,0.2,1.8-0.5,1.8-1.5V61.9z"
          />
          <path
            className="progressBox"
            fill="none"
            stroke="#F3F5F6"
            d="M297.1,50.3c0-0.9-0.9-1.7-1.8-1.5l-49.1,9.6c-0.7,0.1-1.2,0.8-1.2,1.5v46.4
					c0,0.9,0.7,1.5,1.6,1.5l49.1-2.1c0.8,0,1.4-0.7,1.4-1.5V50.3z"
          />
          <path
            className="progressBox"
            fill="none"
            stroke="#F3F5F6"
            d="M297.1,116.5c0-0.8-0.7-1.5-1.5-1.5l-49.1,0.7c-0.8,0-1.5,0.7-1.5,1.5v15.6
					c0,0.8,0.6,1.4,1.4,1.5l49.1,3.3c0.9,0.1,1.6-0.6,1.6-1.5V116.5z"
          />
          <path
            className="progressBox"
            fill="none"
            stroke="#F3F5F6"
            d="M297.1,148.1c0-0.8-0.6-1.4-1.4-1.5l-49.1-4.5c-0.9-0.1-1.6,0.6-1.6,1.5v13.9
					c0,0.7,0.5,1.4,1.2,1.5l49.1,8.4c0.9,0.2,1.8-0.5,1.8-1.5V148.1z"
          />
        </g>
      </svg>
    </div>
  );
};
export default ProgressIdle;
